export default __webpack_public_path__ + "static/media/JPG輪播1-4.434f6153.jpg";